import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

if (window.ENV !== "development") {
  Sentry.init({
    dsn: "https://5d4f598945f34e9fb35da80611bbbdbd@o562027.ingest.sentry.io/5795990",
    integrations: [new Integrations.BrowserTracing()],
    environment: window.ENV,
    tracesSampleRate: 0.2,
    release: window.RELEASE_VERSION,
    ignoreErrors: ["AbortError", "signal is aborted without reason", "The user aborted a request"],
  });

  // Set user context for Sentry error tracking
  if (window.USER_ID && window.USER_ID !== "null") {
    const userId = window.USER_ROLES ? `${window.USER_ID}-${window.USER_ROLES}` : window.USER_ID;

    Sentry.setUser({ id: userId });
  }
}
